import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';
import { FormattedMessage, intlShape, injectIntl } from '../../util/reactIntl';
import { createResourceLocatorString, findRouteByRouteName } from '../../util/routes';
import routeConfiguration from '../../routeConfiguration';
import { propTypes } from '../../util/types';
import { ensureListing, ensureTransaction } from '../../util/data';
import { dateFromAPIToLocalNoon } from '../../util/dates';
import { createSlug } from '../../util/urlHelpers';
import { txIsPaymentPending, txIsEnquired } from '../../util/transaction';
import { getMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { isScrollingDisabled, manageDisableScrolling } from '../../ducks/UI.duck';
import { initializeCardPaymentData } from '../../ducks/stripe.duck.js';
import { sendMail } from '../../util/api';
import { types as sdkTypes } from '../../util/sdkLoader';
import axios from 'axios';
import {
  NamedRedirect,
  TransactionPanel,
  Page,
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  // Footer,
} from '../../components';
import { TopbarContainer } from '../../containers';

import {
  acceptSale,
  declineSale,
  loadData,
  setInitialValues,
  sendMessage,
  sendReview,
  fetchMoreMessages,
  fetchTransactionLineItems,
  confirmPayment,
  requestPayment,
  initiateOrder,
} from './TransactionPage.duck';
import css from './TransactionPage.css';
import config from '../../config';

const PROVIDER = 'provider';
const CUSTOMER = 'customer';
const { UUID } = sdkTypes;
// TransactionPage handles data loading for Sale and Order views to transaction pages in Inbox.
export const TransactionPageComponent = props => {
  const {
    currentUser,
    initialMessageFailedToTransaction,
    savePaymentMethodFailed,
    fetchMessagesError,
    fetchMessagesInProgress,
    totalMessagePages,
    oldestMessagePageFetched,
    fetchTransactionError,
    history,
    intl,
    messages,
    onManageDisableScrolling,
    onSendMessage,
    onSendReview,
    onShowMoreMessages,
    params,
    scrollingDisabled,
    sendMessageError,
    sendMessageInProgress,
    sendReviewError,
    sendReviewInProgress,
    transaction,
    transactionRole,
    acceptInProgress,
    acceptSaleError,
    declineInProgress,
    declineSaleError,
    onAcceptSale,
    onDeclineSale,
    timeSlots,
    fetchTimeSlotsError,
    processTransitions,
    callSetInitialValues,
    onInitializeCardPaymentData,
    onFetchTransactionLineItems,
    // onConfirmPayment,
    // onRequestPayment,
    lineItems,
    fetchLineItemsInProgress,
    fetchLineItemsError,
    ///
    getListing,
    ///
    isAuthenticated,
  } = props;
  const [confirmed, setconfirmed] = useState(false);
  const currentTransaction = ensureTransaction(transaction);
  const currentListing = ensureListing(currentTransaction.listing);
  const isProviderRole = transactionRole === PROVIDER;
  const isCustomerRole = transactionRole === CUSTOMER;
  console.log('isAuthenticated?', isAuthenticated);

  //Confirming payment
  useEffect(
    () => {
      ////console.log('the transa', transaction);
      if (currentTransaction.id && !confirmed) {
        console.log('PAYMENT CONFIRMED IN CODE');
        const { onConfirmPayment } = props;
        onConfirmPayment(currentTransaction);
        setconfirmed(true);
        setTimeout(() => {
          window.location.reload(false);
        }, 2000);
      }

      return () => {};
    },
    [
      /*add 'confirmed', 'currentTransaction', and 'props' - weasel*/
    ]
  );

  const redirectToCheckoutPageWithInitialValues = (initialValues, listing) => {
    const routes = routeConfiguration();
    // Customize checkout page state with current listing and selected bookingDates
    const { setInitialValues } = findRouteByRouteName('CheckoutPage', routes);
    const saveToSessionStorage = !currentUser;
    callSetInitialValues(setInitialValues, initialValues, saveToSessionStorage);

    // Clear previous Stripe errors from store if there is any
    onInitializeCardPaymentData();

    // Redirect to CheckoutPage
    if (initialValues.transaction) {
      history.push(
        createResourceLocatorString(
          'CheckoutPage',
          routes,
          {
            id: currentListing.id.uuid,
            slug: createSlug(currentListing.attributes.title),
          },
          {}
        )
      );
    } else {
      history.push(
        createResourceLocatorString(
          'CheckoutPage',
          routes,
          { id: currentListing.id.uuid, slug: createSlug(currentListing.attributes.title) },
          {}
        )
      );
    }
  };

  //Paying
  // refactor for anon func? - weasel
  const handleSubmit = values => {
    ////console.log('listing is:', values);

    const listingId = listing.id;
    const listing = getListing(listingId);

    const { bookingDates, ...bookingData } = values;
    const initialValues = {
      listing,

      bookingData,

      bookingDates: {
        bookingStart: bookingDates.startDate,
        bookingEnd: bookingDates.endDate,
      },
      confirmPaymentError: null,
    };
    ////console.log('the initial values: ', initialValues);

    const saveToSessionStorage = !currentUser;

    const routes = routeConfiguration();
    // Customize checkout page state with current listing and selected bookingDates
    const { setInitialValues } = findRouteByRouteName('CheckoutPage', routes);

    callSetInitialValues(setInitialValues, initialValues, saveToSessionStorage);
    ////console.log('initial values here:', initialValues);

    // Clear previous Stripe errors from store if there is any
    onInitializeCardPaymentData();

    //request the booking
    // const requestParams = {
    //   listingId: listingId,
    //   bookingStart: bookingDates.startDate,
    //   bookingEnd: bookingDates.endDate,
    //   seats: bookingData.seats,
    // };
    // const initialMessage = 'I would like to book your room !';

    /*onInitiateOrder(requestParams, null).then(params => {
      ////console.log("these are the 'values': ", params);
      const routes = routeConfiguration();
      history.push(
        createResourceLocatorString('OrderDetailsPage', routes, { id: params.id.uuid }, {})
      );
      onSendMessage({ ...params, message: initialMessage })
        .then(values => {
          ////console.log("these are the 'values': " + JSON.stringify(requestParams));

          //console.log("these are the 'values': " + values);
        })
        .then(() => {})
        .catch(e => {
          //this.setState({ submitting: false });
          //console.log('message wasnt sent', e);
        });
    });*/

    // Redirect to CheckoutPage
    history.push(
      createResourceLocatorString(
        'CheckoutPage',
        routes,
        {
          id: listing.id.uuid,
          slug: createSlug(listing.attributes.title),
        },
        {}
      )
    );
  };

  // If payment is pending, redirect to CheckoutPage
  if (
    txIsPaymentPending(currentTransaction) &&
    isCustomerRole &&
    currentTransaction.attributes.lineItems
  ) {
    const currentBooking = ensureListing(currentTransaction.booking);

    const initialValues = {
      listing: currentListing,
      // Transaction with payment pending should be passed to CheckoutPage
      transaction: currentTransaction,
      // Original bookingData content is not available,
      // but it is already used since booking is created.
      // (E.g. quantity is used when booking is created.)
      bookingData: {},
      bookingDates: {
        bookingStart: dateFromAPIToLocalNoon(currentBooking.attributes.start),
        bookingEnd: dateFromAPIToLocalNoon(currentBooking.attributes.end),
      },
    };

    redirectToCheckoutPageWithInitialValues(initialValues, currentListing);
  }

  // Customer can create a booking, if the tx is in "enquiry" state.
  const handleSubmitBookingRequest = values => {
    //console.log(values);
    const { bookingDates, ...bookingData } = values;

    const initialValues = {
      listing: currentListing,
      // enquired transaction should be passed to CheckoutPage
      transaction: currentTransaction,
      bookingData,
      bookingDates: {
        bookingStart: bookingDates.startDate,
        bookingEnd: bookingDates.endDate,
      },
      confirmPaymentError: null,
    };

    redirectToCheckoutPageWithInitialValues(initialValues, currentListing);
  };

  ////////////////////////////////////////////////
  const isEnquired = txIsEnquired(currentTransaction);
  //console.log('the author is', props);
  /*var currentListingAttributes;
      var projectRoomtypeRaw;
      var currentPublicData;
      var currentBedAmount;
      var bookingTitle;
      var ProjectRoomtype;
      var EnqSub;
      var bookingSubTitle;
      var authorDisplayName;
      var isAuthenticated;
      var isCustomer;
      var isProvider;
      if (currentListing.listing) {
        currentListingAttributes = currentListing.attributes;
        projectRoomtypeRaw = currentListingAttributes.description;
        currentPublicData = currentListingAttributes.publicData;
        currentBedAmount = currentPublicData.bedamount;
        bookingTitle = '';
        ProjectRoomtype = currentListingAttributes.description;
        EnqSub = true;
        bookingSubTitle = '';
        authorDisplayName = currentTransaction.listing.author.attributes.profile.displayName;
        isAuthenticated = null;
        isCustomer = true;
        isProvider = false;
      }*/
  // move to page
  const handleBookingSubmitAfterEnq = async values => {
    const {
      history,
      getListing,
      params,
      callSetInitialValues,
      onInitializeCardPaymentData,
      onInitiateOrder,
      onSendMessage,
    } = props;
    const listing = currentListing;
    const listingId = listing.id;

    console.log('Email', values);
    const { bookingDates, ...bookingData } = values;
    const initialValues = {
      listing,

      bookingData,

      bookingDates: {
        bookingStart: currentTransaction.booking.attributes.start,
        bookingEnd: currentTransaction.booking.attributes.end,
      },
      confirmPaymentError: null,
    };

    let providerName = currentTransaction.provider.attributes.profile.displayName;
    let bookingStartDate= currentTransaction.booking.attributes.displayStart.toString().slice(0,16);
    let bookingEndDate = currentTransaction.booking.attributes.displayEnd.toString().slice(0,16);
    const saveToSessionStorage = !currentUser;

    const twilioSid = config.twilio.twilioSID;
    const twilioAuthToken= config.twilio.twilioAuthToken;
    const senderPhone = config.twilio.senderPhone;
    let from = 'whatsapp:'+senderPhone;
    let to = `whatsapp:${currentTransaction.attributes.protectedData.phoneNumber}`;
    let twilioUrl = `https://api.twilio.com/2010-04-01/Accounts/${twilioSid}/Messages.json`;
    let sendNotifications = currentTransaction.provider.attributes.profile?.publicData?.notifications ?? true;

    let listingTitle = listing.attributes.title;
    let hostLanguage =  currentListing.attributes.publicData.country;
    let message = `Hello ${providerName}, \nyou have a new booking request on socialbnb! \nIt was made by ${currentUser.attributes.profile.firstName} from ${bookingStartDate} to ${bookingEndDate} at ${listingTitle}, please visit your inbox.`;
    if(hostLanguage == 'DE'){
       message = `Hallo ${providerName}, \ndu hast eine neue Buchungsanfrage auf socialbnb! \nSie wurde erstellt von ${bookingStartDate} auf ${bookingEndDate} zu ${listingTitle} hat ${currentUser.attributes.profile.firstName}, bitte schau in deine Inbox.`;
      }
     if(sendNotifications){
       await axios.post(twilioUrl, new URLSearchParams({
          Body : message,
          From : from,
          To : to,
       }), {
       auth: {
           username: twilioSid,
           password: twilioAuthToken
           }
        })
        .then(
            response => {
           console.log(response.data.sid);
         },
        error => {
        console.log(error);
         }
         );
     }

    const routes = routeConfiguration();
    // Customize checkout page state with current listing and selected bookingDates
    const { setInitialValues } = findRouteByRouteName('CheckoutPage', routes);

    callSetInitialValues(setInitialValues, initialValues, saveToSessionStorage);
    console.log('initial values here:', listingId);

    // Clear previous Stripe errors from store if there is any
    onInitializeCardPaymentData();

    //request the booking
    const requestParams = {
      listingId: listingId,
      bookingStart: currentTransaction.booking.attributes.start,
      bookingEnd: currentTransaction.booking.attributes.end,
      seats: currentTransaction.booking.attributes.seats,
    };
    const initialMessage = 'I would like to Book your room !';
    onInitiateOrder(requestParams, currentTransaction.id).then(params => {

      const routes = routeConfiguration();
      history.push(
        createResourceLocatorString('OrderDetailsPage', routes, { id: params.id.uuid }, {})
      );
     /* onSendMessage({ ...params, message: initialMessage })
        .then(values => {
          console.log("these are the 'values': " + JSON.stringify(requestParams));

          console.log("these are the 'values': " + values);
        })
        .then(() => {})
        .catch(e => {
          //this.setState({ submitting: false });
          console.log('message wasnt sent', e);
        });*/
    });


    console.log(
      'Emailsent 1',
      `New booking made by ${currentUser.attributes.email} code ${listingId.uuid} from ${initialValues.bookingDates.startDate} to ${initialValues.bookingDates.endDate} `
    );
     sendMail({
      from: process.env.REACT_APP_CONTACT_FROM_MAIL, // sender address
      to: 'booking@socialbnb.de', // list of receivers
      subject: 'New Booking', // Subject line
      text: `New booking made by ${currentUser.attributes.email} code ${listingId.uuid} from ${initialValues.bookingDates.startDate} to ${initialValues.bookingDates.endDate} `, // plain text body
      html: `<b>New booking made by ${currentUser.attributes.email} code ${listingId.uuid} from ${initialValues.bookingDates.startDate} to ${initialValues.bookingDates.endDate}</b>`,
    }).then(res => {
      console.log(res);
    });
  };

  const handleSubmitPaymentRequest = values => {
    const currentBooking = ensureListing(values.booking);
    const { bookingDates, ...bookingData } = currentBooking;

    const initialValues = {
      listing: currentListing,
      speculatedTransaction: currentTransaction,
      // enquired transaction should be passed to CheckoutPage
      transaction: currentTransaction,
      bookingData,
      bookingDates: {
        bookingStart: currentBooking.attributes.start,
        bookingEnd: currentBooking.attributes.end,
      },
      confirmPaymentError: null,
    };

    redirectToCheckoutPageWithInitialValues(initialValues, currentListing);
  };

  const deletedListingTitle = intl.formatMessage({
    id: 'TransactionPage.deletedListing',
  });
  const listingTitle = currentListing.attributes.deleted
    ? deletedListingTitle
    : currentListing.attributes.title;

  // Redirect users with someone else's direct link to their own inbox/sales or inbox/orders page.
  const isDataAvailable =
    currentUser &&
    currentTransaction.id &&
    currentTransaction.id.uuid === params.id &&
    currentTransaction.attributes.lineItems &&
    currentTransaction.customer &&
    currentTransaction.provider &&
    !fetchTransactionError;

  const isOwnSale =
    isDataAvailable &&
    isProviderRole &&
    currentUser.id.uuid === currentTransaction.provider.id.uuid;
  const isOwnOrder =
    isDataAvailable &&
    isCustomerRole &&
    currentUser.id.uuid === currentTransaction.customer.id.uuid;

  if (isDataAvailable && isProviderRole && !isOwnSale) {
    // eslint-disable-next-line no-console
    console.error('Tried to access a sale that was not owned by the current user');
    return <NamedRedirect name="InboxPage" params={{ tab: 'sales' }} />;
  } else if (isDataAvailable && isCustomerRole && !isOwnOrder) {
    // eslint-disable-next-line no-console
    console.error('Tried to access an order that was not owned by the current user');
    return <NamedRedirect name="InboxPage" params={{ tab: 'orders' }} />;
  }

  const detailsClassName = classNames(css.tabContent, css.tabContentVisible);

  const fetchErrorMessage = isCustomerRole
    ? 'TransactionPage.fetchOrderFailed'
    : 'TransactionPage.fetchSaleFailed';
  const loadingMessage = isCustomerRole
    ? 'TransactionPage.loadingOrderData'
    : 'TransactionPage.loadingSaleData';

  const loadingOrFailedFetching = fetchTransactionError ? (
    <p className={css.error}>
      <FormattedMessage id={`${fetchErrorMessage}`} />
    </p>
  ) : (
    <p className={css.loading}>
      <FormattedMessage id={`${loadingMessage}`} />
    </p>
  );

  const initialMessageFailed = !!(
    initialMessageFailedToTransaction &&
    currentTransaction.id &&
    initialMessageFailedToTransaction.uuid === currentTransaction.id.uuid
  );

  // TransactionPanel is presentational component
  // that currently handles showing everything inside layout's main view area.

  const panel = isDataAvailable ? (
    <TransactionPanel
      className={detailsClassName}
      currentUser={currentUser}
      transaction={currentTransaction}
      fetchMessagesInProgress={fetchMessagesInProgress}
      totalMessagePages={totalMessagePages}
      oldestMessagePageFetched={oldestMessagePageFetched}
      messages={messages}
      initialMessageFailed={initialMessageFailed}
      savePaymentMethodFailed={savePaymentMethodFailed}
      fetchMessagesError={fetchMessagesError}
      sendMessageInProgress={sendMessageInProgress}
      sendMessageError={sendMessageError}
      sendReviewInProgress={sendReviewInProgress}
      sendReviewError={sendReviewError}
      onManageDisableScrolling={onManageDisableScrolling}
      onShowMoreMessages={onShowMoreMessages}
      onSendMessage={onSendMessage}
      onSendReview={onSendReview}
      onRequestPayment={handleSubmitPaymentRequest}
      //onBookingAfterEnq={handleBookingSubmitAfterEnq}
      onConfirmBooking={handleBookingSubmitAfterEnq}
      transactionRole={transactionRole}
      onAcceptSale={onAcceptSale}
      onDeclineSale={onDeclineSale}
      acceptInProgress={acceptInProgress}
      declineInProgress={declineInProgress}
      acceptSaleError={acceptSaleError}
      declineSaleError={declineSaleError}
      nextTransitions={processTransitions}
      onSubmitBookingRequest={handleSubmitBookingRequest}
      timeSlots={timeSlots}
      fetchTimeSlotsError={fetchTimeSlotsError}
      onFetchTransactionLineItems={onFetchTransactionLineItems}
      lineItems={lineItems}
      fetchLineItemsInProgress={fetchLineItemsInProgress}
      fetchLineItemsError={fetchLineItemsError}
    />
  ) : (
    loadingOrFailedFetching
  );

  return (
    <Page
      title={intl.formatMessage({ id: 'TransactionPage.title' }, { title: listingTitle })}
      scrollingDisabled={scrollingDisabled}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <div className={css.root}>{panel}</div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter className={css.footer}>{/* <Footer /> */}</LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};

TransactionPageComponent.defaultProps = {
  currentUser: null,
  fetchTransactionError: null,
  acceptSaleError: null,
  declineSaleError: null,
  transaction: null,
  fetchMessagesError: null,
  initialMessageFailedToTransaction: null,
  savePaymentMethodFailed: false,
  sendMessageError: null,
  timeSlots: null,
  fetchTimeSlotsError: null,
  lineItems: null,
  fetchLineItemsError: null,
};

const { bool, func, oneOf, shape, string, array, arrayOf, number } = PropTypes;

TransactionPageComponent.propTypes = {
  params: shape({ id: string }).isRequired,
  transactionRole: oneOf([PROVIDER, CUSTOMER]).isRequired,
  currentUser: propTypes.currentUser,
  fetchTransactionError: propTypes.error,
  acceptSaleError: propTypes.error,
  declineSaleError: propTypes.error,
  acceptInProgress: bool.isRequired,
  declineInProgress: bool.isRequired,
  onAcceptSale: func.isRequired,
  onDeclineSale: func.isRequired,
  scrollingDisabled: bool.isRequired,
  transaction: propTypes.transaction,
  fetchMessagesError: propTypes.error,
  totalMessagePages: number.isRequired,
  oldestMessagePageFetched: number.isRequired,
  messages: arrayOf(propTypes.message).isRequired,
  initialMessageFailedToTransaction: propTypes.uuid,
  savePaymentMethodFailed: bool,
  sendMessageInProgress: bool.isRequired,
  sendMessageError: propTypes.error,
  onShowMoreMessages: func.isRequired,
  onSendMessage: func.isRequired,
  timeSlots: arrayOf(propTypes.timeSlot),
  fetchTimeSlotsError: propTypes.error,
  callSetInitialValues: func.isRequired,
  onInitializeCardPaymentData: func.isRequired,
  onFetchTransactionLineItems: func.isRequired,

  // line items
  lineItems: array,
  fetchLineItemsInProgress: bool.isRequired,
  fetchLineItemsError: propTypes.error,

  // from withRouter
  history: shape({
    push: func.isRequired,
  }).isRequired,
  location: shape({
    search: string,
  }).isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  const {
    fetchTransactionError,
    acceptSaleError,
    declineSaleError,
    acceptInProgress,
    declineInProgress,
    transactionRef,
    fetchMessagesInProgress,
    fetchMessagesError,
    totalMessagePages,
    oldestMessagePageFetched,
    messages,
    initialMessageFailedToTransaction,
    savePaymentMethodFailed,
    sendMessageInProgress,
    sendMessageError,
    sendReviewInProgress,
    sendReviewError,
    timeSlots,
    fetchTimeSlotsError,
    processTransitions,
    lineItems,
    fetchLineItemsInProgress,
    fetchLineItemsError,
  } = state.TransactionPage;
  const { currentUser } = state.user;

  const transactions = getMarketplaceEntities(state, transactionRef ? [transactionRef] : []);
  const transaction = transactions.length > 0 ? transactions[0] : null;

  return {
    currentUser,
    fetchTransactionError,
    acceptSaleError,
    declineSaleError,
    acceptInProgress,
    declineInProgress,
    scrollingDisabled: isScrollingDisabled(state),
    transaction,
    fetchMessagesInProgress,
    fetchMessagesError,
    totalMessagePages,
    oldestMessagePageFetched,
    messages,
    initialMessageFailedToTransaction,
    savePaymentMethodFailed,
    sendMessageInProgress,
    sendMessageError,
    sendReviewInProgress,
    sendReviewError,
    timeSlots,
    fetchTimeSlotsError,
    processTransitions,
    lineItems,
    fetchLineItemsInProgress,
    fetchLineItemsError,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onInitiateOrder: (params, transactionId) => dispatch(initiateOrder(params, transactionId)),
    onAcceptSale: transactionId => dispatch(acceptSale(transactionId)),
    onDeclineSale: transactionId => dispatch(declineSale(transactionId)),
    onShowMoreMessages: txId => dispatch(fetchMoreMessages(txId)),
    onSendMessage: (txId, message) => dispatch(sendMessage(txId, message)),
    onManageDisableScrolling: (componentId, disableScrolling) =>
      dispatch(manageDisableScrolling(componentId, disableScrolling)),
    onSendReview: (role, tx, reviewRating, reviewContent) =>
      dispatch(sendReview(role, tx, reviewRating, reviewContent)),
    callSetInitialValues: (setInitialValues, values) => dispatch(setInitialValues(values)),
    onInitializeCardPaymentData: () => dispatch(initializeCardPaymentData()),
    onFetchTransactionLineItems: (bookingData, listingId, isOwnListing) =>
      dispatch(fetchTransactionLineItems(bookingData, listingId, isOwnListing)),
    onConfirmPayment: params => dispatch(confirmPayment(params)),
    onRequestPayment: params => dispatch(requestPayment(params)),
  };
};

const TransactionPage = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl
)(TransactionPageComponent);

TransactionPage.loadData = loadData;
TransactionPage.setInitialValues = setInitialValues;

export default TransactionPage;
